// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"styles__msignaturepad___28YM0","m-signature-pad--body":"styles__m-signature-pad--body___292-I","m-signature-pad--footer":"styles__m-signature-pad--footer___FmJfJ","description":"styles__description___xPm3W","button":"styles__button___3MEMj","clear":"styles__clear___3s9jp","save":"styles__save___3741_","m-signature-pad":"styles__m-signature-pad___2-Tj5","github":"styles__github___1YnoH","circular":"styles__circular___gsBGi","rotate":"styles__rotate___1P_Q2","path":"styles__path___1ekgi","dash":"styles__dash___M6o6a","color":"styles__color___2xVvS"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/Loading/styles.scss
// module id = NDtc
// module chunks = client